/**
 * This file is part of an epic that is currently on hold and is not being used in the application.
 * Please refer to the README.md file in the root of the PDFRenderer directory for more information.
 */
import { Image, Text, View } from "@react-pdf/renderer";
import React from "react";

import { usePdfSettings } from "../../PdfSettingsContext";
import { StylesFn, usePdfStyles } from "../../styles";

declare global {
	interface Window {
		PERFORMYARD_MEDIA_CDN: string;
	}
}

const MEDIA_CDN = window?.PERFORMYARD_MEDIA_CDN || "https://performyard-content.performyard.com/";
const COMPANY_LOGO_URL = `${MEDIA_CDN}company-logo/`;

const pageFooterStyles: StylesFn = (scale) => {
	return {
		pageFooter: {
			position: "absolute",
			bottom: 24,
			left: 0,
			right: 0,
		},
		pageFooterCompanyName: {
			fontSize: scale(12),
			position: "absolute",
			left: 16,
		},
		pageFooterPageNumber: {
			fontSize: scale(12),
			position: "absolute",
			right: 16,
		},
		pageFooterCompanyLogo: {
			position: "absolute",
			left: 16,
			height: scale(24),
		},
	};
};

type PageFooterProps = {
	company: {
		_id: string;
		name: string;
	};
};
export const PageFooter = ({ company: { _id, name } }: PageFooterProps) => {
	const { includeCompanyLogoFooter } = usePdfSettings();
	const styles = usePdfStyles(pageFooterStyles);

	return (
		<View fixed style={styles.pageFooter}>
			{includeCompanyLogoFooter ? (
				<Image style={styles.pageFooterCompanyLogo} src={`${COMPANY_LOGO_URL}${_id}`} />
			) : (
				<Text style={styles.pageFooterCompanyName}>{name}</Text>
			)}
			<Text
				style={styles.pageFooterPageNumber}
				fixed
				render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
			/>
		</View>
	);
};
